import React, { useRef, useEffect } from 'react';
import { useLocation, Route, Routes } from 'react-router-dom';
import ScrollReveal from './utils/ScrollReveal';
import { initialize, set, pageview } from 'react-ga';

// Layouts
import LayoutDefault from './layouts/LayoutDefault';

// Views 
import Home from './views/Home';
import Coating from './views/Coating';
import PPF from './views/PPF';
import Correction from './views/Correction';
import Exterior from './views/Exterior';
import Interior from './views/Interior';
import Gallery from './views/Gallery';
import PriceList from './views/Services';

// Initialize Google Analytics
initialize(process.env.REACT_APP_GA_CODE);

const trackPage = page => {
  set({ page });
  pageview(page);
};

const App = () => {

  const childRef = useRef();
  let location = useLocation();

  useEffect(() => {
    const page = location.pathname;
    document.body.classList.add('is-loaded')
    childRef.current.init();
    trackPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <ScrollReveal ref={childRef}>
      <LayoutDefault>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/pricelist" element={<PriceList />} />
          <Route exact path="/coating" element={<Coating />} />
          <Route exact path="/ppf" element={<PPF />} />
          <Route exact path="/correction" element={<Correction />} />
          <Route exact path="/exterior" element={<Exterior />} />
          <Route exact path="/interior" element={<Interior />} />
          <Route exact path="/gallery" element={<Gallery />} />
        </Routes>
      </LayoutDefault>
    </ScrollReveal>
  );
}

export default App;